import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import type { BlogPost } from "@/lib/blog-types";

export function ArticleCard({ post }: { post: BlogPost }) {
  return (
    <Link
      to="/blog/$slug"
      params={{ slug: post.slug }}
      className="flex h-full flex-col rounded-2xl border border-border bg-card p-5 transition-colors hover:border-primary/40"
    >
      <div className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-widest text-primary/60">
        {post.category}
        {post.isPillar && <span className="rounded-full bg-primary/10 px-2 py-0.5 text-primary">Guide</span>}
      </div>
      <div className="mt-2 font-display font-bold text-primary">{post.title}</div>
      <p className="mt-2 line-clamp-3 text-sm text-foreground/70">{post.quickAnswer ?? post.intro}</p>
      <div className="mt-auto pt-4 text-xs text-muted-foreground">
        {new Date(post.updatedAt ?? post.publishedAt).toLocaleDateString("en-ZA", {
          year: "numeric",
          month: "short",
          day: "numeric",
        })}
      </div>
      <span className="mt-2 inline-flex items-center gap-1 text-xs font-semibold text-primary">
        Read article <ArrowRight className="h-3 w-3" />
      </span>
    </Link>
  );
}
